import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Approch.module.css';

const Approch = () => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className={`container-fluid my-5 ${styles.app}`}>
      <div className="row">
        <div className="col-lg-6 order-lg-first">
          <video className="w-100 shadow" autoPlay muted loop>
            <source src="video/about.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="col-lg-6 order-lg-last">
        <div className={`p-3 ${styles.textWrapper}`}>
        <div style={{ textAlign: "center" }}></div>
            <h2 className={styles.heading}>Our Approach</h2>
            <p className="lead">
              At Narayani Solutions, we believe in a client-centric approach that prioritizes understanding
              unique business challenges and goals. Our tailored solutions are designed to not only meet
              but exceed expectations. We collaborate closely with our clients, ensuring transparency,
              flexibility, and a seamless integration of our technology solutions into their workflows.
            </p>
            <div className={styles.buttonWrapper}>
  <Link
    to="/about"
    onClick={handleClick}
    className={`btn ${styles.btnCustom}`}
  >
    About Us
  </Link>
</div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Approch;
